import { render, staticRenderFns } from "./AltegioLink.vue?vue&type=template&id=50a7c316&scoped=true"
import script from "./AltegioLink.vue?vue&type=script&lang=js"
export * from "./AltegioLink.vue?vue&type=script&lang=js"
import style0 from "./AltegioLink.vue?vue&type=style&index=0&id=50a7c316&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a7c316",
  null
  
)

export default component.exports